module.exports = __webpack_public_path__ + "static/img/8areaA_07.0dff564.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/8areaA_07.png
// module id = 927
// module chunks = 1